import ApiGroupCard from './ApiGroupCard';

export default ApiGroupCard;
